import Api from '@/api/Api'

export default {
  fetchAll () {
    return Api().get('AdminInterest/fetch_all')
  }
}



// WEBPACK FOOTER //
// ./src/api/AdminInterestAPI.js